import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { GeoFenceModifyRequest } from "./GeoFenceModifyRequest";
import { GeoFenceDeleteRequest } from "./GeoFenceDeleteRequest";

@Injectable()
export class DataService_BusTrackerGeoFenceMaintenance {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	BusMapPreferenceSelect(PersonID) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusMapPreferenceSelect?PersonID=" + PersonID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusAlertTypeSelectList(ActiveOnly) {
		var postResult$ = new Subject();
		var url = "BusTracker/BusAlertTypeSelectList?ActiveOnly=" + ActiveOnly;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GeoFenceSelectList() {
		var postResult$ = new Subject();
		var url = "BusTracker/GeoFenceSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	BusSelectorSelectList() {
		var postResult$ = new Subject();
		var url = "BusTracker/BusSelectorSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GeoFenceTriggerTypeSelectList() {
		var postResult$ = new Subject();
		var url = "BusTracker/GeoFenceTriggerTypeSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SeveritySelectList() {
		var postResult$ = new Subject();
		var url = "BusTracker/SeveritySelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GeoFenceInsert(parms: GeoFenceModifyRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/GeoFenceInsert";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GeoFenceUpdate(parms: GeoFenceModifyRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/GeoFenceUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	GeoFenceDelete(parms: GeoFenceDeleteRequest) {
		var postResult$ = new Subject();
		var url = "BusTracker/GeoFenceDelete";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
